import { ReactComponent as Back } from "./back.svg";
import { SvgIcon } from "@material-ui/core";

export default function BackButton(props) {
  return <SvgIcon {...props} component={Back} viewBox="0 0 34 34" />;
}
